export const MIN_SCALE = 25;
export const MAX_SCALE = 400;
